import React, { useState, useEffect } from "react";
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import BLMMapPage from "./components/BLMMapPage";
import { AppProvider, useAppContext } from "./context/AppContext";
import { HeaderProvider, useHeaderContext } from "./context/HeaderContext";
import Navbar from "./components/Navbar";
// import Sidebar from "./components/Sidebar";
import BottomNav from "./components/BottomNav";
import HomePage from "./pages/HomePage";

import PlanPage from "./pages/PlanPage";
import GearPage from "./pages/GearPage";
import MapPage from "./pages/MapPage";
// import TestPage from "./pages/TestPage"; // Removed for production
// import DebugPage from "./pages/DebugPage";
import VendorsPage from "./pages/VendorsPage";
import BLMPage from "./pages/BLMPage";
// import BLMCard from "./components/BLMCard"; // Replaced by BLMMapPage
import PersistentHeader from "./components/PersistentHeader";
import OnxPage from "./pages/OnxPage";
import AdminPage from "./pages/AdminPage";


const MainLayout = () => {
  const { darkMode, mode, user: appUser, currentTab, setCurrentTab } = useAppContext();
  const { setUser: setHeaderUser } = useHeaderContext();

  // Sync user from AppContext to HeaderContext
  React.useEffect(() => {
    setHeaderUser(appUser);
  }, [appUser, setHeaderUser]);

  // Log environment variables
  useEffect(() => {
  }, []);

  let Content;
  switch (currentTab) {
    case "Bureau of Land Management (BLM)":
      Content = <BLMMapPage />;
      break;
    case "BLMCard":
      Content = <BLMMapPage />;
      break;
    case "Home":
      Content = <HomePage />;
      break;
    case "Plan":
      Content = <PlanPage />;
      break;
    case "Gear":
      Content = <GearPage />;
      break;
    case "Map":
      Content = <MapPage />;
      break;
    case "Vendors":
      Content = <VendorsPage />;
      break;
    case "BLM":
      Content = <BLMMapPage />;
      break;
    case "BLM Recreation Points":
      Content = <BLMMapPage />;
      break;
    case "OnX":
      Content = <OnxPage />;
      break;
    case "Admin":
      Content = <AdminPage />;
      break;
    case "BLM Map Page":
      Content = <BLMMapPage />;
      break;
    // case "Test":
    //   Content = <TestPage />;
    //   break;
    // case "Debug":
    //   Content = <DebugPage />;
    //   break;
  }

  return (
    <div className={darkMode ? "dark" : ""}>
      {mode === "beginner" && <PersistentHeader />}
      <div className="flex min-h-screen bg-gray-100 dark:bg-gray-800">
        {/* Sidebar Navigation removed for production */}
        {/* <Sidebar currentTab={currentTab} setCurrentTab={setCurrentTab} /> */}
        {/* Main content */}
        <div className="flex-1 flex flex-col">
          <Navbar />
          {/* ✅ Add padding-bottom so content clears the bottom nav */}
          <main className="flex-1 p-4 pt-16 pb-20">{Content}</main>
        </div>
        {/* Bottom Navigation Bar */}
        <BottomNav currentTab={currentTab} setCurrentTab={setCurrentTab} />
      </div>
    </div>
  );
};


// AppProvider must wrap HeaderProvider so all hooks are called within their correct provider
const App = () => (
  <AppProvider>
    <HeaderProvider>
      <MainLayout />
    </HeaderProvider>
  </AppProvider>
);

export default App;
